import { render, staticRenderFns } from "./EnrollColor2.vue?vue&type=template&id=d3dac9b2&"
import script from "./EnrollColor2.vue?vue&type=script&lang=js&"
export * from "./EnrollColor2.vue?vue&type=script&lang=js&"
import style0 from "./EnrollColor2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports